module.exports = __webpack_public_path__ + "img/rodas_populares.3eaadd0b.jpg";